import html from '../../assets/icons/html.png';
import css from '../../assets/icons/css.png';
import javascript from '../../assets/icons/javascript.svg';
import redux from '../../assets/icons/redux.svg';
import react from '../../assets/icons/react.svg';
import node from '../../assets/icons/node-js.svg';
import vscode from '../../assets/icons/visual-studio-code.svg';
import express from '../../assets/icons/express-js.svg';
import aws from '../../assets/icons/amazon-web-services.svg';
import git from '../../assets/icons/git.svg';
import mui from '../../assets/icons/material-ui.svg';
import jest from '../../assets/icons/jest.svg';
import reactTestingLib from '../../assets/icons/react-testing-lib.png';
import gitlab from '../../assets/icons/gitlab.svg';
import postman from '../../assets/icons/postman.svg';

export default [
    {
       stack: "ReactJs",
       width: "90%",
       img: react
    },
    {
        stack: "Javascript",
        width: "90%",
        img: javascript
     },
     {
        stack: "Redux",
        width: "75%",
        img: redux
     },
     {
        stack: "NodeJs",
        width: "60%",
        img: node
     },
     {
        stack: "HTML",
        width: "90%",
        img: html
     },
     {
        stack: "CSS/SCSS",
        width: "80%",
        img: css
     },
     {
        stack: "Material UI",
        width: "90%",
        img: mui
     },
     {
         stack: "ExpressJs",
         width: "90%",
         img: express
      },
      {
         stack: "AWS",
         width: "75%",
         img: aws
      },
      {
         stack: "Visual Studio Code",
         width: "60%",
         img: vscode
      },
      {
         stack: "GIT",
         width: "80%",
         img: git
      },
      {
         stack: 'Jest',
         width: "50%",
         img: jest
      },
      {
         stack: 'React Testing Library',
         width: "50%",
         img: reactTestingLib
      },
      {
         stack: 'Gitlab',
         width: "100%",
         img: gitlab
      },
      {
         stack: 'Postman',
         width: "80%",
         img: postman
      }
]